import React, { FC } from "react"
import { useNavigate } from "react-router-dom"
import { useTypedSelector } from "@hooks/useTypedSelector";
import Sticker from "../../../components/elements/sticker/Sticker";
import Container from "../../../components/elements/container/Container";
import Tx from "../../../types/naming"
import { ApiSelect, TextType } from "@baseTypes/baseType";
import st from "./styles.module.scss"
import StickerHeader from "../../../components/elements/sticker/StickerHeader";
import { stickerLoadingWithCrop } from "../phases";
import * as Highcharts from "highcharts";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { Empty } from "./empty";
import { identity } from "fp-ts/es6/function";
import { CropDashboardState } from "../../../store/reducers/dashboard/crops/types";
import { formatNumber2d } from "@utils/format/number";
import { LegendRow, toggleSeries } from "@elements/Legend/Legend";
import CropsChart from "@pages/dashboard/crops/chart";
import { isEmpty } from "lodash";

interface CropsDashboardProps {
    baseCropId?: any
}

export const pieLegendToggler = (chartApi?: Highcharts.Chart) => (el: LegendRow) =>
    toggleSeries(chartApi?.series[0].points, el.id)

export const columnRangeLegendToggler = (chartApi?: Highcharts.Chart) => (el: LegendRow) =>
    toggleSeries(chartApi?.series, el.id)

export const cropChartSelector: ApiSelect<CropDashboardState> =
    createSelector((state: RootState) => state.dashCrops, identity<CropDashboardState>)

const CropsDashboard: FC<CropsDashboardProps> = () => {
    const navigate = useNavigate();

    const {
        data: {
            totalGeoZoneHa,
            cultivatedArea }
    } = useTypedSelector(cropChartSelector)

    
    const { selected } = useTypedSelector(state => state.cropSelector);

    const onHeaderClick = () => {
        navigate(`crops`)
    }

    const renderBody = () => <>
        <StickerHeader
            textType={TextType.Header}
            onClick={onHeaderClick}
            isLink={true}
            title={Tx.Culture}
            rightPlacement={() => formatNumber2d(totalGeoZoneHa) + " Га"}
        />
        <Container>
            <CropsChart cultivatedArea={cultivatedArea} totalGeoZoneHa={totalGeoZoneHa} />
        </Container>
    </>


    return (
        <Sticker className={st.sticker}>
            {cultivatedArea && !isEmpty(cultivatedArea) && selected && !isEmpty(selected) ? renderBody() : <Empty/>}
        </Sticker>
    )
}

export default stickerLoadingWithCrop(cropChartSelector, actions => actions.fetchDashboardCrops)(CropsDashboard);